<template>
  <div>
    <div class="d-flex align-items-center">
      <span style="font-size: 14px; color: #606266">
        No：{{ formData.amzReplenishmentNo || '--' }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        {{ formData.amzPeriodTitle || '' }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <el-tag
        size="mini"
        :type="
          formData.replenishmentStatus === 'N'
            ? 'primary'
            : formData.replenishmentStatus === 'D'
            ? 'danger'
            : formData.replenishmentStatus === 'P'
            ? 'warning'
            : formData.replenishmentStatus === 'Y'
            ? 'success'
            : formData.replenishmentStatus === 'S'
            ? 'logistics'
            : 'info'
        "
      >
        {{ formData.v_replenishmentStatus }}
      </el-tag>
      <el-divider direction="vertical"></el-divider>
      <el-tag
        v-if="formData.v_skuSalesChannel"
        size="mini"
        :type="
          formData.skuSalesChannel === 'F'
            ? 'success'
            : formData.skuSalesChannel === 'V'
            ? 'warning'
            : ''
        "
      >
        {{ formData.v_skuSalesChannel }}
      </el-tag>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Update：{{ formData.modifyByName || '--' }} at
        {{ formData.modifyDate || '--' }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        {{ $l('table_label_submitReplyTotalCtnCbm') || '已返答总箱体积' }}：
      </span>
      <span style="font-size: 14px; color: #409EFF">
        {{ `${format(submitReplyTotalCtnCbm) || '0'}(m³)` }}
      </span>
    </div>
    <SkuTable
      :amzReplenishmentCode="amzReplenishmentCode"
      :disabled="disabled"
      :isVc="isVc"
      @reload="getSubmitReplyTotalCtnCbm"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import SkuTable from '../sku-table'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  components: { SkuTable },
  props: {
    amzReplenishmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return { formData: {}, submitReplyTotalCtnCbm: 0, format }
  },
  computed: {
    isVc() {
      const { skuSalesChannel } = this.formData
      return skuSalesChannel == 'V' ? 'Y' : 'N'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzReplenishmentCode) return
      const params = { amzReplenishmentCode: this.amzReplenishmentCode }
      const res = await this.$api
        .ecomAmzReplenishmentDetailApi(params)
        .catch(() => null)
      this.formData = res?.body || {}
    },
    async getSubmitReplyTotalCtnCbm() {
      if (!this.amzReplenishmentCode) return
      const res = await this.$api
        .ecomAmzReplenishmentSubmitReplyTotalCtnCbmApi(
          this.amzReplenishmentCode
        )
        .catch(() => null)
      this.submitReplyTotalCtnCbm = res?.body || 0
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
::v-deep {
  .el-tag--logistics {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
